<template>
  <div>
      <div v-if="loading || loading2">
        <p >Loading...</p>
      </div>
      <div v-else-if="activeExamInfo && currentDoctorData" id="invoice-page" class="px-6 py-3">

          <div class="flex flex-wrap items-center justify-between no-print">
            <vx-input-group class="mb-base mr-3">
            </vx-input-group>
            <div class="flex items-center">
              <!-- <vs-button class="mb-base" style="margin-right:35px;" icon-pack="feather" icon="icon icon-edit" color="warning">Editar</vs-button>
              <vs-button class="mb-base mr-3" type="border" icon-pack="feather" icon="icon icon-download">Descargar</vs-button> -->
              <vs-button class="mb-base mr-3" type="border" icon-pack="feather"  icon="icon icon-file" @click="printInvoice">Imprimir</vs-button>
            </div>
          </div>

          <vx-card id="invoice-container">

              <!-- INVOICE METADATA -->
              <div class="vx-row leading-loose p-base">
                  <div class="vx-col w-1/2 mt-base">
                      <img :src="doctorLogo" alt="Evolugy" style="max-width: 200px; max-height: 120px;">
                  </div>
                  <div class="vx-col w-1/2 text-right">
                      <h1>Solicitud de Examen</h1>
                      <div class="invoice__invoice-detail mt-6">
                          <h6>Examen NO.</h6>
                          <p>{{ activeExamInfo.id }}</p>

                          <h6 class="mt-4">Fecha</h6>
                          <p>{{new Date(activeExamInfo.created_at).toLocaleDateString('es-ES', dateStringOptions)}}</p>
                      </div>
                  </div>
                  <div class="vx-col w-1/2 mt-12">
                      <h5>Paciente</h5>
                      <div class="invoice__recipient-info my-4">
                        <p> {{ activeExamInfo.patient.first_name}} {{ activeExamInfo.patient.last_name}} </p>
                        <p> {{ activeExamInfo.patient.address ? activeExamInfo.patient.address : ''}} </p>
                        <p> {{ activeExamInfo.patient.address_2 ? activeExamInfo.patient.address_2 : ''}} </p>
                        <p> 
                          {{ activeExamInfo.patient.city ? activeExamInfo.patient.city+' ,': ''}}
                          {{ activeExamInfo.patient.country ? activeExamInfo.patient.country: ''}}
                        </p>
                      </div>
                      <div class="invoice__recipient-contact ">
                          <p class="flex items-center" v-if="activeExamInfo.patient.email">
                            <feather-icon icon="MailIcon" svgClasses="h-4 w-4"></feather-icon>
                            <span class="ml-2">{{ activeExamInfo.patient.email }}</span>
                        </p>
                        <p class="flex items-center" v-if="activeExamInfo.patient.phone">
                            <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4"></feather-icon>
                            <span class="ml-2"> {{ activeExamInfo.patient.phone[0] }}</span>
                        </p>
                      </div>
                  </div>
                  <div class="vx-col w-1/2 mt-base text-right mt-12">
                      <h5> {{ currentDoctorData.first_name }} {{ currentDoctorData.last_name}} </h5>
                    <div class="invoice__company-info my-4">
                        <p>{{ currentDoctorData.address }}</p>
                        <p>{{ currentDoctorData.address_2 }}</p>
                        <p>{{ currentDoctorData.city ? currentDoctorData.city+', ' : '' }} {{ currentDoctorData.country }}</p>
                    </div>
                    <div class="invoice__company-contact">
                        <p class="flex items-center justify-end">
                            <feather-icon icon="MailIcon" svgClasses="h-4 w-4"></feather-icon>
                            <span class="ml-2">{{ currentDoctorData.email }}</span>
                        </p>
                        <p class="flex items-center justify-end">
                            <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4"></feather-icon>
                            <span class="ml-2">{{ currentDoctorData.phone[0] }}</span>
                        </p>
                    </div>
                  </div>
              </div>

              <div class="vx-row leading-loose p-base" v-if="activeExamInfo.recommendations">
                  <div class="vx-col w-1/2 mt-base">
                    <h5>Recomendaciones: </h5>
                    <p> {{activeExamInfo.recommendations}} </p>
                  </div>
              </div>

              <!-- INVOICE CONTENT -->
              <div class="p-base">
                  <!-- INVOICE TASKS TABLE -->
                  <vs-table hoverFlat v-if="activeExamInfo.meta && activeExamInfo.meta.exams" :data="activeExamInfo.meta.exams">
                      <!-- HEADER -->
                      <template slot="thead">
                          <vs-th class="pointer-events-none">Nombre</vs-th>
                          <vs-th class="pointer-events-none">Tipo</vs-th>
                          <vs-th class="pointer-events-none">Instrucciones</vs-th>

                      </template>

                      <!-- DATA -->
                      <template slot-scope="{data}">
                          <vs-tr v-for="(tr, index) in data" :key="index">
                              <vs-td :data="data[index].task">{{ data[index].name }}</vs-td>
                              <vs-td :data="data[index].hours">{{ data[index].type }}</vs-td>
                              <vs-td :data="data[index].rate">{{ data[index].instructions }}</vs-td>

                          </vs-tr>
                      </template>
                  </vs-table>
              </div>

              <!-- INVOICE FOOTER -->
            <div class="text-center mt-5" v-if="!doctorSignature">
              <p class="mb-4">Dr {{currentDoctorData.first_name}} {{currentDoctorData.last_name}} </p>
              <p class="mb-4">Firma: ___________________________</p>
            </div>
            <vs-row class="mb-2" vs-type="flex" vs-justify="center" v-else>
              <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                  <img :src="doctorSignature" alt="Firma" style="max-width: 160px; max-height: 80px;">
              </vs-col>
            </vs-row>

            <div class="invoice__footer text-right p-base" v-if="false">
                <p class="mb-4">Instrucciones y datos generales.</p>
                <p>
                    <span class="mr-8">Receta: <span class="font-semibold">{{activePrescriptionInfo.id}}</span></span>
                    <span>Sello: <span class="font-semibold"> _______________________</span></span>
                </p>
            </div>
          </vx-card>
      </div>
  </div>
</template>

<script>

export default{
  data () {
    return {
      doctorLogo: '@/assets/images/logo/logo.png',
      doctorSignature: null,
      currentDoctorData: {},
      loading: true,
      loading2: true,
      mailTo: '',
      dateStringOptions:  { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
      companyDetails: {
        name: 'Microsion Technologies Pvt. Ltd.',
        addressLine1: '9 N. Sherwood Court',
        addressLine2: 'Elyria, OH',
        zipcode: '94203',
        mailId: 'hello@pixinvent.net',
        mobile: '+91 999 999 9999'
      },
      recipientDetails: {
        fullName: 'Peter Stark',
        addressLine1: '8577 West West Drive ',
        addressLine2: 'Holbrook, NY',
        zipcode: '90001',
        mailId: 'peter@mail.com',
        mobile: '+91 988 888 8888'
      },
      invoiceDetails: {
        invoiceNo: '001/2019',
        invoiceDate: 'Mon Dec 10 2018 07:46:00 GMT+0000 (GMT)'
      },
      invoiceData: {
        meds: [
          {
            id: 1,
            task: 'MEdi',
            inst: 'No consumir alimentos altos en almidones y azucares durante una semana, y realizar actividad física ligera',
            mol: 'diclofenaco',
            lab: 'DenkPharma',
            freq: '1 vez al día',
            rate: 15,
            amount: 90000
          },
          {
            id: 2,
            task: 'Vital fuerte',
            inst: 'Bebida líquida vitaminada tres veces al día',
            mol: 'Multi Vitaminas',
            lab: 'DenkPharma',
            freq: '3 veces al día',
            rate: 12,
            amount: 24000
          }
        ],
        subtotal: 114000,
        discountPercentage: 5,
        discountedAmount: 5700,
        total: 108300
      }
    }
  },
  computed: {
    activeExamInfo(){
      return this.$store.state.activeExamInfo
    },
  },
  beforeCreate(){
    console.log(this.$route);
    this.$store.dispatch('getExamByIdPublic', this.$route.params.exam_id).then(response => {
          console.log(response);
          this.loading = false;

      }, error => {
          console.error(error);
      }); 

    this.$store.dispatch('getUserDataByIdPublic', this.$route.params.doctor_id).then(response => {
        console.log(response);
        this.currentDoctorData = JSON.parse(JSON.stringify(response.data.data.user));
        this.doctorLogo = this.currentDoctorData.meta.logo_url ?  this.currentDoctorData.meta.logo_url : this.doctorLogo;
        this.doctorSignature = this.currentDoctorData.meta.signature_url ?  this.currentDoctorData.meta.signature_url : null;
        this.loading2 = false;
        }, error => {
            console.error(error);
        }
    ); 
  },
  methods: {
    printInvoice () {
      window.print()
    }
  },
  components: {},
  mounted () {
    this.$emit('setAppClasses', 'invoice-page');
    console.log(this.currentDoctorData);
  }
}
</script>

<style lang="scss">
@media print {
  .no-print, .no-print *
    {
        display: none !important;
    }

  .invoice-page {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    .vs-con-table {
      .vs-con-tbody {
        overflow: hidden !important;
      }
    }

    #invoice-container,
    #invoice-container * {
      visibility: visible;
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}

@page {
  size: auto;
}
</style>
<style scoped>
body{
        touch-action: manipulation;
    }
</style>